import { render, staticRenderFns } from "./MiddleHeaderComponent.vue?vue&type=template&id=b0e437b2&lang=pug&"
import script from "./MiddleHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./MiddleHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports